import React from 'react';
import Thumbnail from '../Media/Thumbnail/Thumbnail';
import cx from 'classnames';

const GalleryCard = (props) => {
  const {
    handleClick,
    handleEnter,
    mediaId,
    isActive,
    mediaType,
    name,
    thumbnail,
    alt = ''
  } = props;

  const thumbnailClassNames = cx('stop-thumbnail', {
    active: isActive
  });

  return (
    <button
      className="stop-thumbnail__img-btn"
      onClick={handleClick}
      onKeyPress={handleEnter}
      data-cy="stop-thumbnail__img-btn"
      type="button"
    >
      <Thumbnail
        mediaId={mediaId}
        thumbSrc={thumbnail}
        mediaType={mediaType}
        thumbClass={thumbnailClassNames}
        name={name}
        height={180}
        alt={alt}
        view
      />
      {name}
    </button>
  )
};

export default GalleryCard;
